import "./App.css"
import BlogHome from "./components/Blog/BlogHome"

function App() {
  return (
    <>
      <BlogHome />
    </>
  )
}

export default App
